<template>
	<!-- 记事信息 -->
  <div class="mod-config">
	<el-card body-style="padding-bottom: 0;">
		<el-form ref="form" :model="form" inline label-width="80px" label-position="left">
			<el-row>
				<el-col :span="16">
					<el-form-item>
						<el-tag type="danger">{{getSituationTypeName()}}</el-tag>
					</el-form-item>
					<el-form-item label="登记时间">
						<el-date-picker
						  class="selItemInput"
						  v-model="recContentTime"
						  value-format="yyyy-MM-dd"
						  type="daterange"
						  range-separator="至"
						  start-placeholder="开始日期"
						  end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="8" class="selBtnGroup">
					<el-button v-preventReClick class="primaryPlainBtn" type="primary" plain size="mini" icon="el-icon-back" @click="returnMenu">返回</el-button>
					<el-button v-preventReClick class="primaryPlainBtn" type="primary" plain size="mini" icon="el-icon-refresh" @click="resetFormData()">重置</el-button>
					<el-button v-preventReClick class="primaryPlainBtn" type="primary" plain size="mini" icon="el-icon-search" @click="selGetDataList()" v-if="showSearch">检索</el-button>
				</el-col>
			</el-row>
		</el-form>
	</el-card>
	<el-row style="margin-top: 20px;">
		<el-col :span="pageSpan" v-if="showAdd">
			<el-button v-preventReClick class="defaultPlainBtn" plain icon="el-icon-circle-plus-outline" @click="addOrUpdateHandle()">添加</el-button>
		</el-col>
		<el-col :span="pageSpan" style="text-align: right;">
			<el-pagination
			  background
			  layout="prev, pager, next"
			  :pager-count="5"
			  @current-change="currentChangeHandle"
			  :current-page="page"
			  :page-size="limit"
			  :total="totalCount">
			</el-pagination>
		</el-col>
	</el-row>
	<el-row :gutter="20">
		<el-col :span="8" style="margin-top: 20px;" v-for="(item,index) in dataList">
			<el-card>
				<el-row>
					<el-col :span="12">
						<span style="color: #00428e; margin-right: 10px; font-weight: bold;">登记时间</span>
						<span style="color: #727580;">{{item.registerTime}}</span>
					</el-col>
					<el-col :span="12">
						<span style="color: #00428e; margin-right: 10px; font-weight: bold;">登记人</span>
						<span style="color: #727580;">{{item.registerMan}}</span>
					</el-col>
					<el-col :span="24">
						<div class="noteTitle">重要事项</div>
						<div class="noteContent" style="height: 60px; line-height: 30px; overflow: hidden;">
							{{item.situationContent}}
						</div>
						<div style="text-align: right; margin-top: 20px;" v-if="showDelete || showEdit">
							<el-button v-preventReClick class="primaryPlainBtn" type="primary" size="mini" plain icon="el-icon-edit-outline" @click="addOrUpdateHandle(item.recNo)" v-if="showEdit">修改</el-button>
							<el-button v-preventReClick class="primaryPlainBtn" type="primary" size="mini" plain icon="el-icon-delete" @click="deleteHandle(item.recNo)" v-if="showDelete">删除</el-button>
						</div>
					</el-col>
				</el-row>
			</el-card>
		</el-col>
	</el-row>
	<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList()"></add-or-update>
  </div>
</template>
<script>
	import AddOrUpdate from './qualitySituationList-add-or-update'
	import $common from "@/utils/common.js"
	export default {
	  data() {
		return {
			showSearch: true,
			showAdd: true,
			showEdit: true,
			showDelete: true,
			pageSpan: 12,
			subjectNo: $common.getItem("subjectNo"),
			form:{},
			// subjectList:[],
			dataList:[],
			recContentTime:[],
			// subjectNo:"",
			limit: 6,
			page: 1,
			totalCount:0,
		    addOrUpdateVisible: false,
			situationType: ''
		};
	  },
	  components: {
		  AddOrUpdate
	  },
	  mounted() {
		  this.situationType = this.$route.query.type;
		  // this.showSearch = $common.isAuth('qualitySituation:search:'+this.situationType);
		  // this.showAdd = $common.isAuth('qualitySituation:add:'+this.situationType);
		  // this.showEdit = $common.isAuth('qualitySituation:edit:'+this.situationType);
		  // this.showDelete = $common.isAuth('qualitySituation:delete:'+this.situationType);
		  if (!this.showAdd){
			  this.pageSpan = 24;
		  }
	  	this.getDataList();
	  },
	  methods: {
		  getSituationTypeName(){
			  if (this.situationType === '00'){
				  return '停止点检查（报验)情况 总体描述';
			  }else  if (this.situationType === '10'){
				  return '质量问题跟踪';
			  }  else if (this.situationType === '15'){
				  return '巡检检查情况-总体描述';
			  } else if (this.situationType === '20'){
				  return '突出问题跟踪';
			  } else if (this.situationType === '30'){
				  return 'HSE情况';
			  } else if (this.situationType === '40'){
				  return '设计修改及审图意见落实情况';
			  } else if (this.situationType === '99'){
				  return '其他需要说明的问题';
			  } else if (this.situationType === '80'){
				  return '本周监理工作概括-情况综述描述';
			  } else if (this.situationType === '81'){
				  return '进度情况-进度分析描述';
			  } else if (this.situationType === '82'){
				  return '进度情况-设计进度情况描述';
			  } else if (this.situationType === '83'){
				  return '进度情况-生产及技术准备情况描述';
			  } else if (this.situationType === '84'){
				  return '一周质量情况-巡检情况描述';
			  }else if (this.situationType === '85'){
				  return '安全生产/HSE情况描述';
			  }else if (this.situationType === '86'){
				  return '监理建议或意见描述';
			  }

		  },
		selGetDataList(){
			this.page = 1;
			this.getDataList();
		},
		  returnMenu(){
			  this.$router.go(-1)
		  },
		resetFormData(){
			this.subjectNo = "";
			this.recContentTime = [];
		},
		currentChangeHandle(val) {
			this.page = val
			this.getDataList()
		},
		getDataList(){
			if (this.showSearch) {
				this.$http({
					url: this.$store.state.httpUrl + "/business/qualitysituationinfo/list",
					method: "get",
					params: {
						limit: this.limit,
						page: this.page,
						subjectNo:this.subjectNo,
						situationType: this.situationType,
						beginTime: this.recContentTime[0] ? this.recContentTime[0] : '',
						endTime: this.recContentTime[1] ? this.recContentTime[1] : '',
						workNo: $common.getItem("workNo")
					},
				}).then(({data}) => {
					if (data && data.code === 200) {
						this.dataList = data.body.records;
						this.totalCount = data.body.totalCount;
					}
				});
			}
		},
		addOrUpdateHandle(id){
			this.addOrUpdateVisible = true
			this.$nextTick(() => {
			  this.$refs.addOrUpdate.init(id,this.situationType)
			})
		},
		deleteHandle (id) {
			this.$confirm(`您确定要删除选择的数据么?`, '提示', {
		        confirmButtonText: '确定',
		        cancelButtonText: '取消',
		        type: 'warning'
		    }).then(() => {
		        this.$http({
					url:  this.$store.state.httpUrl + "/business/qualitysituationinfo/delete/"+id,
		            method: 'post',
		            data: {}
		        }).then(({data}) => {
		            if (data && data.code === 200) {
		                this.$message({
		                    message: '操作成功',
		                    type: 'success',
		                    duration: 1500,
		                    onClose: () => {
		                        this.getDataList()
		                    }
		                })
		            } else {
		                this.$message.error(data.msg)
		            }
		        })
		    })
		},
	  }
	};
</script>
<style lang="scss" scoped="scoped">
	.noteTitle{
		font-weight: bold;
		color: #00428e;
		border-bottom: 1px solid #00428e;
		padding-bottom: 10px;
		margin-top: 20px;
	}
	.noteContent{
		color: #727580;
		margin-top: 10px;
		line-height: 25px;
	}
</style>
scope
